export default __webpack_public_path__ + "static/media/scale.0ce90d18.svg";